import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController, Platform, IonSlides, AlertController } from '@ionic/angular';
import moment from "moment";

@Component({
  selector: 'app-on-signup-free-plan',
  templateUrl: './on-signup-free-plan.component.html',
  styleUrls: ['./on-signup-free-plan.component.scss'],
})
export class OnSignupFreePlanComponent implements OnInit {
  freeTrialDays;
  freeTrialStartedAt;
  offerVideo;
  couponCode;
  data;
  country;
  freeTrialEndDateDiff;
  countdownHours;
  countdownMins;
  countdownSec;
  @ViewChild("activitySlide", { static: false }) activitySlide: IonSlides;
  constructor(
    private modalController: ModalController,
    private _sanitizer: DomSanitizer,
    private router: Router,
    ) { 
      let a = moment(new Date(localStorage.getItem("freeTrialStartedAt")), "DD.MM.YYYY");
      let b = moment(new Date(), "DD.MM.YYYY");
      this.freeTrialEndDateDiff = a.diff(b, 'days');

      if(this.freeTrialEndDateDiff == 0){
        let self = this;
        let x = setInterval(function () {
          let todaysMidTime = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0,0,0,0);
          let currentTime = new Date().getTime();
          let t = todaysMidTime - currentTime;
    
          let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((t % (1000 * 60)) / 1000);
          
          self.countdownHours = (hours <= 9 ? "0" + hours : hours);
          self.countdownMins = (minutes <= 9 ? "0" + minutes : minutes);
          self.countdownSec = (seconds <= 9 ? "0" + seconds : seconds);
          // self.countdownTimerText = (minutes <= 9 ? "0" + minutes : minutes) + ":" + (seconds <= 9 ? "0" + seconds : seconds);
        }, 1000);
      }
    }

    slideOptsActivity = {
      initialSlide: 0,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: false,
      autoplay: true
    };

    activitySlider = [{
      "image": "./assets/img/free-plan/diet-plan-analysis-free-plan.svg",
      "title": "Diet Plan Analysis",
      "subtitle": "Understand Science behind recommendations",
      "bgcolor":"#ffa601"
    },{
      "image": "./assets/img/free-plan/weight-analysis-free-plan.svg",
      "title": "Nutri check",
      "subtitle": "Know the relative ranking to choose the best food items",
      "bgcolor":"#f8719f"
    },{
      "image": "./assets/img/free-plan/daily-diet-reco-free-plan.svg",
      "title": "Daily Diet Recommendation",
      "subtitle": "We give best Diet recommendations for each slot of the day",
      "bgcolor":"#509bee"
    },{
      "image": "./assets/img/free-plan/7-days-free-plan.svg",
      "title": "7 Days Diet Plan",
      "subtitle": "Plan Diet and groceries before hand with the 7 days diet plan",
      "bgcolor":"#ffa610"
    },{
      "image": "./assets/img/free-plan/detox-plan-free-plan.png",
      "title": "Detox Plan",
      "subtitle": "Accelerate the journey with a low calories Detox plan",
      "bgcolor":"#f8719f"
    },{
      "image": "./assets/img/free-plan/calories-analysis-free-plan.svg",
      "title": "Calories Planning",
      "subtitle": "To achieve 0.5 to 1kg weight loss, we plan 3500 calories deficit in 7 days",
      "bgcolor":"#51c877"
    },{
      "image": "./assets/img/free-plan/meal-fasting-free-plan.svg",
      "title": "Manage Fasting Timings",
      "subtitle": "Fast with ease using fasting tracker and make it a life time habit",
      "bgcolor":"#51c877"
    }];

  ngOnInit() {}

  close() {
    this.modalController.dismiss();
  }

  startFreeTrial(){
    let data = {
      startFreeTrial: true
    }
    this.modalController.dismiss(data);
  }

  sanitizeVideo(videoUrl){
    return this._sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
  }

  startSpecialTrial(){
    let data = {
      startSpecialTrial: true
    }
    this.modalController.dismiss(data);
  }
}
